/**
 * Loại quyết định — Kết nối nền tảng số
 */
export default {
  Active: '0', // Chủ động
  ByRequest: '1', // Theo đơn
};
